if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      toggleLoading() {
        this.submitButton.toggleAttribute("disabled");
        this.submitButton.classList.toggle("loading");
        this.querySelector(".loading-overlay__spinner").classList.toggle(
          "hidden"
        );
      }

      getAddedAddOns(arr) {
        return arr.map((item) => {
          return {
            quantity: 1,
            id: parseInt(item.dataset.variantId),
          };
        });
      }

      productWithAddonsSubmit() {
        this.addOns = Array.from(
          this.closest("product-info").querySelectorAll(
            ".complementary-product-item.added"
          )
        );

        console.log(this.addOns[0].classList);

        this.handleErrorMessage();
        this.toggleLoading();

        const routeUrl = routes.cart_add_url;
        const body = JSON.stringify({
          // items: [
          //   {
          //     quantity: 1,
          //     id: parseInt(this.form.querySelector('[name="id"]').value),
          //   },
          // ].concat(this.getAddedAddOns(this.addOns)),
          ...(this.addOns[0].classList.contains("replace")
            ? {
                items: this.getAddedAddOns(this.addOns),
              }
            : {
                items: [
                  {
                    quantity: 1,
                    id: parseInt(this.form.querySelector('[name="id"]').value),
                  },
                ].concat(this.getAddedAddOns(this.addOns)),
              }),
          ...(this.cart
            ? {
                sections: this.cart
                  .getSectionsToRender()
                  .map((section) => section.id),
              }
            : {}),
          sections_url: window.location.pathname,
        });

        fetch(`${routeUrl}`, { ...fetchConfig("javascript"), ...{ body } })
          .then((response) => response.json())
          .then((response) => {
            if (!this.cart || window.location.pathname == "/cart") {
              window.location = `${window.routes.cart_url}?addons=true`;
              return;
            }

            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.toggleLoading();

            if (document.querySelector("fixed-atc-bar .button.loading"))
              document.querySelector("fixed-atc-bar").toggleLoading(true);
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (
          this.closest("product-info")?.querySelector(
            "product-recommendations .complementary-product-item.added"
          )
        ) {
          this.productWithAddonsSubmit();
          return;
        }

        this.handleErrorMessage();
        this.toggleLoading();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart || this.closest("modal-frame")) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    if (this.dataset.upsellModal) {
                      this.cart.renderContents(response, true);
                      document
                        .querySelector(`#${this.dataset.upsellModal}`)
                        .show(this.submitButton);

                      this.closest("quick-add-modal")
                        .querySelector("remote-mobile-button")
                        .buttonReset();
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (this.dataset.upsellModal) {
              this.cart.renderContents(response, true);
              document
                .querySelector(`#${this.dataset.upsellModal}`)
                .show(this.submitButton, true);

              this.submitButton.removeAttribute("aria-disabled");
              this.submitButton.classList.remove("loading");
              this.submitButton
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );

            if (document.querySelector("fixed-atc-bar .button.loading"))
              document.querySelector("fixed-atc-bar").toggleLoading(true);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );

  class FixedATCBar extends HTMLElement {
    constructor() {
      super();

      this.mainProductForm = document.querySelector("[data-main-product]");
      this.submitButton = this.querySelector(".button");
      this.handleScroll = this.handleScroll.bind(this);

      this.submitButton.addEventListener(
        "click",
        this.handleButtonClick.bind(this)
      );
    }

    connectedCallback() {
      if (
        !this.mainProductForm ||
        !window.matchMedia("(max-width: 749px)").matches
      )
        return;

      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
    }

    handleButtonClick() {
      this.toggleLoading();
      const submitEvent = new Event("submit", {
        bubbles: true,
        cancelable: true,
      });
      this.mainProductForm.querySelector("form").dispatchEvent(submitEvent);
    }

    handleScroll() {
      const rect = this.mainProductForm.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (!isVisible) {
        // console.log("ATC not intersecting !!!!");
        this.classList.add("stickky");
      } else {
        // console.log("ATC intersecting !!!!");
        this.classList.remove("stickky");
      }
    }

    toggleLoading(hide = false) {
      this.submitButton.toggleAttribute("disabled");
      this.submitButton.classList.toggle("loading");
      this.querySelector(".loading-overlay__spinner").classList.toggle(
        "hidden"
      );

      hide && this.classList.remove("stickky");
    }
  }

  customElements.define("fixed-atc-bar", FixedATCBar);
}
